import { EstimationInput } from '../../App';
import { EmissionCategories, throwIfAnyUndefined } from '../calculations';
import { EmissionCalculationInTonnes } from '../../configs/industryCalculationTemplate';
import { getRangeValue } from '../../../util/getRangeValue';

export const calculateEcommerce = (
  emissionsCategories: EmissionCategories,
  input: EstimationInput,
): EmissionCalculationInTonnes => {
  //docs.google.com/spreadsheets/d/1W_JkPp8H6ah4D_V8Ept5MukoOVZEx-X3/edit#gid=1968029027
  const { employees } = input;
  const {
    ecommerce_vehicles_tonnes,
    ecommerce_electricity_tonnes,
    ecommerce_airTravel_tonnes,
    ecommerce_accomodation_tonnes,
    ecommerce_taxisRentalCars_tonnes,
    ecommerce_commuting_tonnes,
    ecommerce_water_tonnes,
    ecommerce_waste_tonnes,
    ecommerce_vehicleRanges_tonnes,
    ecommerce_accomodationRanges_tonnes,
    ecommerce_freightRanges_tonnes,
    ecommerce_freight_tonnes,
  } = emissionsCategories;

  throwIfAnyUndefined(
    [
      ecommerce_vehicles_tonnes,
      ecommerce_electricity_tonnes,
      ecommerce_airTravel_tonnes,
      ecommerce_accomodation_tonnes,
      ecommerce_taxisRentalCars_tonnes,
      ecommerce_commuting_tonnes,
      ecommerce_water_tonnes,
      ecommerce_waste_tonnes,
      ecommerce_vehicleRanges_tonnes,
      ecommerce_accomodationRanges_tonnes,
    ],
    'e-commerce',
  );

  const vehicleMatrix = getRangeValue(
    employees,
    ecommerce_vehicleRanges_tonnes.ranges,
    ecommerce_vehicleRanges_tonnes.outOfRange,
  );

  const accomodationMatrix = getRangeValue(
    employees,
    ecommerce_accomodationRanges_tonnes.ranges,
    ecommerce_accomodationRanges_tonnes.outOfRange,
  );

  const vehicles = ecommerce_vehicles_tonnes * vehicleMatrix;

  const electricity = ecommerce_electricity_tonnes * employees;
  const airTravel = ecommerce_airTravel_tonnes * employees;
  const accomodation =
    ecommerce_accomodation_tonnes *
    accomodationMatrix *
    (employees > 4 ? employees : 1);

  const taxisRentalCars = ecommerce_taxisRentalCars_tonnes * employees;
  const commuting = ecommerce_commuting_tonnes * employees;
  const water = ecommerce_water_tonnes * employees;
  const waste = ecommerce_waste_tonnes * employees;

  const freightMatrix = getRangeValue(
    employees,
    ecommerce_freightRanges_tonnes.ranges,
    ecommerce_freightRanges_tonnes.outOfRange,
  );

  console.log({ vehicleMatrix });
  console.log({ accomodationMatrix });
  console.log({ freightMatrix });
  console.log({ vehicles });
  console.log({ electricity });
  console.log({ airTravel });
  console.log({ accomodation });
  console.log({ taxisRentalCars });
  console.log({ commuting });
  console.log({ water });
  console.log({ waste });

  const tonnes =
    vehicles +
    electricity +
    airTravel +
    accomodation +
    taxisRentalCars +
    commuting +
    water +
    waste +
    freightMatrix;
  return tonnes;
};
